import {
  GURUS_GET,
  GURU_JENJANGS_GET,
  GURU_ADD,
  GURU_EDIT,
  GURU_GET,
  GURU_DELETE,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    currentPage: '',
    searchText: '',
    itemPerPage: '',
  },
  items: [],
  jenjangs: [],
  gurusImport: [],
};

const gurusGet = (state, payload) => {
  const gurus = payload.gurus;
  return {
    ...state,
    total: gurus.total,
    items: [...gurus.items],
    search: { ...gurus.search },
  };
};

const guruJenjangsGet = (state, payload) => {
  const jenjangs = payload.jenjangs;
  return {
    ...state,
    jenjangs: [...jenjangs],
  };
};

const guruAdd = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) + 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.guru.id + ''),
      payload.guru,
    ],
  };
};

const guruEdit = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.guru.id + ''),
      payload.guru,
    ],
  };
};

const guruGet = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.guru.id + ''),
      payload.guru,
    ],
  };
};

const guruDelete = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) - 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.guru.id + ''),
    ],
  };
};

export default createReducer(initialState, {
  [GURUS_GET]: gurusGet,
  [GURU_JENJANGS_GET]: guruJenjangsGet,
  [GURU_ADD]: guruAdd,
  [GURU_EDIT]: guruEdit,
  [GURU_GET]: guruGet,
  [GURU_DELETE]: guruDelete,
});
